import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor to handle errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const requestOTP = async (email) => {
  const response = await api.post('/auth/request-otp', { email });
  return response.data;
};

export const verifyOTP = async (email, otp, organisationId) => {
  const response = await api.post('/auth/verify-otp', { email, otp, organisationId });
  return response.data;
};

export const verifyToken = async () => {
  const response = await api.get('/auth/verify-token');
  return response.data;
};

export const getUserOrganisations = async (email) => {
  const response = await api.get('/auth/organisations', { params: { email } });
  return response.data;
};

// Organisation API
export const getOrganisations = async () => {
  const response = await api.get('/organisations');
  return response.data;
};

export const getOrganisationDetail = async (id) => {
  const response = await api.get(`/organisations/${id}`);
  return response.data;
};

export const getOrganisationGroups = async (id) => {
  const response = await api.get(`/organisations/${id}/groups`);
  return response.data;
};

export const getOrganisationAdmins = async (id) => {
  const response = await api.get(`/organisations/${id}/admins`);
  return response.data;
};

export const createOrganisation = async (data) => {
  const response = await api.post('/organisations', data);
  return response.data;
};

export const updateOrganisation = async (id, data) => {
  const response = await api.put(`/organisations/${id}`, data);
  return response.data;
};

export const deleteOrganisation = async (id) => {
  const response = await api.delete(`/organisations/${id}`);
  return response.data;
};

// Group API
export const getGroupDetail = async (id) => {
  const response = await api.get(`/groups/${id}`);
  return response.data;
};

export const createGroup = async (data) => {
  const response = await api.post('/groups', data);
  return response.data;
};

export const updateGroup = async (id, data) => {
  const response = await api.put(`/groups/${id}`, data);
  return response.data;
};

export const deleteGroup = async (id) => {
  const response = await api.delete(`/groups/${id}`);
  return response.data;
};

export default api;